"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryBuilder_1 = require("../queryBuilder");
var Set = /** @class */ (function () {
    function Set() {
    }
    Set.prototype.resource = function () {
        return 'sets';
    };
    Set.find = function (id) {
        return queryBuilder_1.QueryBuilder.find(this, id)
            .then(function (response) {
            return response;
        });
    };
    Set.all = function () {
        return queryBuilder_1.QueryBuilder.all(this)
            .then(function (response) {
            return response;
        });
    };
    Set.where = function (params) {
        return queryBuilder_1.QueryBuilder.where(this, params)
            .then(function (response) {
            return response;
        });
    };
    return Set;
}());
exports.Set = Set;
//# sourceMappingURL=set.js.map